<template>
  <div>
  <b-row class="justify-content-center" style="width: 101.1%; height: 50px; overflow: hidden; background: white;">
      <div class="col-md-12">
     <a href="/">
      <img :src="logo" style="width: 190px; padding: 10px 20px;">
    </a>
      </div>
    </b-row>
  <div class="app flex-row align-items-center" v-bind:style="{ 'background-image': 'url(' + bg_img + ') !important', 'min-height': '92vh', 'background-repeat': 'repeat-x !important'}">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <h1>Customer OTP Login</h1>
     
                          
                <b-input-group class="mb-3">
                  <p> IN +91{{loginData.number}} <b-button type="button" variant="link" class="px-4" @click.prevent="changenumber()">change number?</b-button></p>
                  <!-- <input type="text" class="form-control" placeholder="Phone" name="both" id="both" v-model="loginData.both" required> -->
                </b-input-group>

                 <b-input-group class="mb-3">
                  <input type="text" class="form-control" placeholder="Enter OTP" name="both" id="both" v-model="loginData.Otp" required>
                </b-input-group>
                <b-row>
                  <b-col cols="12"  v-if="Verifiednumber == false">
                   <b-button type="button" variant="primary" class="px-4" @click.prevent="loginwithotp()">Continue</b-button>
                  </b-col>
                </b-row>



              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
 
     <Spinner v-if="loading"></Spinner>
  </div>
</div>
</template>

<script>
import {mapState} from 'vuex'
import Spinner from '../../spinner.vue'

export default {
  name: 'Generateotp',
  components :{
    Spinner
  },
  computed:{

  },
  data()  {
    return {
      logo:null,
      bg_img:null,
      remember:0,
      loading:false,
      status_color:'alert alert-success',
      warningModal: false,
      warningModal1: false,
      resetemail:'',
      resetpassword:'',
      resettoken:'',
      resetpasswordconf:'',
      checkwarningmodel1:'',
      verfiy_color:'alert alert-success',
      loginData:{
        number:'',
        Otp:''
      },
       customertoken:'',
      customerdata : [],
      Verifiednumber : false,
      hasErrors:{
        both:false,
        password:false,
        message:false
      },
      errorMessage:{
        verifyemail:null,
        both:null,
        password:null,
        message:null,
        statusemail:null
      }
    }
  },
  created(){
    this.logo = this.baseURL2 + '/design/img/logo.png';
    this.bg_img = this.baseURL2 + '/design/img/ban1.jpg';
    var is_remember = this.getCookie('is_remember')
    // var company_id = this.getCookie('company_id')
    var username = this.getCookie('nummber')

    if(is_remember == 'true'){
      this.remember = true
      this.loginData.number = username
    }

    this.test();
  },

  methods:{
    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    test(){
        this.logo = this.baseURL2 + '/design/img/logo.png';
        this.bg_img = this.baseURL2 + '/design/img/ban1.jpg';
        var is_remember = this.getCookie('is_remember')
        // var company_id = this.getCookie('company_id')
        var username = this.getCookie('username')

        if(is_remember == 'true'){
        this.remember = true
        this.loginData.both = username
        }
        // console.log('testing')
            var Number = JSON.parse(localStorage.getItem('customerphonenumber'))
            this.loginData.number = Number;

        var data = {
            CustomerPhonenumber : this.loginData.number
        }

    // this.$http.post('/api/customers/generateotp', data).then(function (response)
    // {
    //       if(response.status=== 200){
    //           alert(response.data)
    //       }else if(response.status=== 401){
    //         _this.loading=false
    //       } else {
    //          _this.loading=false
    //       }
    //     }).catch(function (error) {
    //       console.log('error')
    //       console.log(error)
    //       _this.loading=false
    //       vm.message = true
    //       _vm.message = error.response.data.error.message
    //     });



    },
    
   

    
  

    changenumber(){
    //   console.log(this.customerdata)
    
      this.$router.props = [this.customerdata.cust_cmp_phone];
      localStorage.setItem("customerphonenumber", '');
      this.$router.push("/verification");

    },

    loginwithotp(){

      var _this = this
      var vm = this.hasErrors
      var _vm = this.errorMessage
      if(this.loginData.Otp==='' || this.loginData.Otp===null ){
        vm.both = true
        _vm.both = "OTP Required"
      }
      else{
        this.loading=true
        
        var log = {
            phonenumber  : this.loginData.number,
            phoneotp : this.loginData.Otp
        }

        if(this.remember){
          document.cookie = 'is_remember=true';
          document.cookie = 'username='+this.loginData.number 
        }else{
          document.cookie = 'is_remember=false';
          document.cookie = 'username='           
        }
        console.log('aaray')
        console.log(log)
        this.$http.post('/api/customers/loginotp', log).then(function (response)
        // this.$http.post('/api/users/customerlogin', log).then(function (response)
         {
           var custtok = null
          // console.log(response.data !=null)
          if(response.data!== null){
            
        var log = {}
            log.phone= response.data[0].cust_cmp_phone,
            log.password=response.data[0].password,
            log.customertoken = custtok
          

         
        _this.$http.post('/api/customers/setpassword').then(function (response){
           
        
         if(response.status=== 200){
           

          
            // _this.$store.dispatch('setUserObject',response.data.id)
            // localStorage.setItem('authUser', response.data.id)
            // localStorage.setItem('authUserid', response.data.customer_id)
              
            // _this.$store.commit('set_is_admin', false)

            // localStorage.setItem('authUserstatus', status)
            _this.$router.push('/setpassword');
             _this.loading=false

          }else if(response.status=== 401){
            _this.loading=false
             _this.$router.push('/customerlogin');
          } else {
             _this.loading=false
          }
        })
        .catch(function (error) {

          console.log(error)
          _this.loading=false
          vm.message = true
          _vm.message = error.response.data.error.message
        });
          }else if(response.data === null){
               console.log('else loop')
            _this.loading=false
          } 
        })
        .catch(function (error) {

          console.log(error)
          _this.loading=false
          vm.message = true
          _vm.message = error.response.data.error.message
        });
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/goldcustomers/Generateotp.vue